module.exports = __webpack_public_path__ + "img/full2-min.b9f1a8f8.png";